import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import FormField from "components/FormField";
import { v4 as uuid } from "uuid";
import { useTheme } from "@mui/material/styles";

const Telefonos = ({ formData }) => {
  const { values, touched, errors, handleChange, setFieldValue } = formData;
  const telefonos = values.telefonos || [];
  const theme = useTheme();
  const accentColor = theme.palette.accent?.main;

  useEffect(() => {
    // Inicializar con un teléfono vacío si no hay ninguno
    if (telefonos.length === 0) {
      setFieldValue("telefonos", [
        { id: uuid(), tipo: "Móvil", telefono: "", isCreated: true },
      ]);
    }
  }, [telefonos.length, setFieldValue]);

  const handleAdd = () => {
    setFieldValue("telefonos", [
      ...telefonos,
      { id: uuid(), tipo: "Móvil", telefono: "", isCreated: true },
    ]);
  };

  const handleRemove = (index) => {
    const newTelefonos = telefonos.filter((_, i) => i !== index);
    setFieldValue("telefonos", newTelefonos);
  };

  return (
    <MDBox>
      {telefonos.map((tel, index) => (
        <MDBox key={tel.id || index} mb={1}>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Icon
                sx={{
                  color: accentColor,
                  fontSize: "2rem !important", // Make it slightly larger as per design usually
                }}
              >
                {tel.tipo === "Móvil" ? "phone_iphone" : "phone"}
              </Icon>
            </Grid>
            <Grid item xs>
              <FormField
                type="tel"
                label=""
                name={`telefonos[${index}].telefono`}
                value={tel.telefono}
                onChange={handleChange}
                placeholder="Número de teléfono"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Select
                        value={tel.tipo}
                        onChange={(e) =>
                          setFieldValue(
                            `telefonos[${index}].tipo`,
                            e.target.value
                          )
                        }
                        variant="standard"
                        disableUnderline
                        sx={{
                          minWidth: 80,
                          "& .MuiSelect-select": {
                            paddingRight: "24px", // Make space for arrow
                            display: "flex",
                            alignItems: "center",
                          },
                          "& .MuiSelect-icon": {
                            display: "block !important",
                          },
                        }}
                      >
                        <MenuItem value="Móvil">Móvil</MenuItem>
                        <MenuItem value="Fijo">Fijo</MenuItem>
                      </Select>
                      {/* Separator line like in the image if needed, but standard select is fine */}
                      <MDBox
                        sx={{
                          width: "1px",
                          height: "20px",
                          backgroundColor: "#ccc",
                          mx: 1,
                        }}
                      />
                    </InputAdornment>
                  ),
                }}
                error={
                  errors.telefonos &&
                  errors.telefonos[index] &&
                  errors.telefonos[index].telefono &&
                  touched.telefonos &&
                  touched.telefonos[index] &&
                  touched.telefonos[index].telefono
                }
                success={
                  tel.telefono.length === 10 &&
                  (!errors.telefonos || !errors.telefonos[index])
                }
                onInput={(e) => {
                  let value = ("" + e.target.value).replace(/[^0-9]/g, "");
                  if (value.length > 10) value = value.slice(0, 10);
                  e.target.value = value;
                }}
                noMarginBottom
              />
            </Grid>
            <Grid item>
              <MDBox display="flex" alignItems="center">
                {index === telefonos.length - 1 ? (
                  <IconButton onClick={handleAdd} color="info">
                    <Icon>add</Icon>
                  </IconButton>
                ) : (
                  <IconButton onClick={() => handleRemove(index)} color="error">
                    <Icon>delete</Icon>
                  </IconButton>
                )}
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      ))}
    </MDBox>
  );
};

Telefonos.propTypes = {
  formData: PropTypes.shape({
    values: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
};

export default Telefonos;
